<nav class="caHeader">
  <div class="headerLogo">
    <img src="..\assets\images\vp-construction-logo.svg" alt="logo" />
  </div>
  @if (!showError) {
    <h1>{{ reportFriendlyName }} {{ reportSecondName }}</h1>
  }
</nav>
@if (!showError) {
  <div #reportElement class="reportView" id="embedReport"></div>
}
@if (showError) {
  <div class="errorContainer reportView">
    <h1>{{ errorTitle }}</h1>
    <p>{{ errorMessage }}</p>
  </div>
}
<app-authenticated-footer></app-authenticated-footer>
